/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div class="container-header"><div class="inner-box caldendar-date-style"><mpx-scroll-view scroll-x enable-flex :enhanced="(true)" bounces :scroll-options="({ bounce: {top: true,bottom: true,left: true,right: true} })" :scroll-into-view="(scrollLeft)" scroll-with-animation id="scrollview"><div :style="[({width: days.length > 5 ? (days.length + 1) * 63 + 'px' : 'calc(100% + 1px)'})] | transRpxStyle" class="calendar"><mpx-view v-for="(item, index) in (days)" :key="item['{{index}}']" :id="('day-item-' + index)" :class="({ isActived: index === chosed, noCheck:!item.canCheck})" @tap="handleClickDay(index,item)" class="calendar-item"><span :class="({ isActivedText: index === chosed })" class="week">{{item.weekText}}</span><span :class="({ isActivedText: index === chosed })" class="date">{{item.dateText}}</span></mpx-view></div></mpx-scroll-view><mpx-view @tap="handleMoreClick" class="more"><div class="more-text"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/PeQ8bmXWAHVco7e9oNYuR.png" class="more-icon"></mpx-image>更多</div></mpx-view></div></div><es-popup :show="(show)" :closeable="(closeable)" @close="onClose" position="bottom"><es-calendar :value="(innerVal)" :disabled="(disabled)" :type="(checkType)" :title="(title)" :formatter="(formatter)" :color="(color)" :show-confirm="(showConfirm)" :start-text="(startText)" :end-text="(endText)" :confirm-text="(confirmText)" :first-day="(firstDay)" :max-range="(maxRange)" :maxDate="(innerMaxDate)" :minDate="(innerMinDate)" :format="(format)" :allow-same-day="(allowSameDay)" @confirm="onConfirm" @input="onInput"></es-calendar></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m549eb962"}'>
  .container-header
    display flex
    justify-content center
    color #10294D
    font-size 12px
    font-weight 500
    position relative
    margin-bottom 8px
    // background #FFFFFF
  .inner-box
    height 44px
    width 100%
    overflow hidden
    display flex
    margin-top 7.93px
    margin-bottom 6.44px
  .week
    font-size 11px
    font-family Ping Fang SC
    font-weight 400
    color #666666
  .calendar
    display flex
    height 100%
    flex-wrap nowrap
    flex-direction row
  .calendar-item
    display flex
    width 55px
    height 42px
    flex-shrink 0
    flex-direction column
    justify-content center
    text-align center
    box-sizing border-box
    margin-right 8px
    &:first-child
      margin-left 8px
  .date 
    font-family Barlow Semi Condensed
    font-size 16px
    font-weight 400
    color #000
  .isActived
    border-radius 7px
    background #FF6400
  .isActivedText
    color #ffffff 
  .noCheck
    color #BBBBBB
  .more
    position absolute
    right 0
    top 5px
    background #fff
    width 55px
    height 50px
    display flex
    justify-content center
    align-items center
    &::before
      // display inline-block
      content ''
      position absolute
      top 0
      left -20px
      background url('https://dpubstatic.udache.com/static/dpubimg/xbwB5ItEJBECZ7VlQYvU7.png')
      height 50px
      width 20px
  .more-text
    display flex
    flex-direction column
    justify-content center
    align-items center
    text-align center
    color #666666
    font-weight 400
    font-size 11px
    .more-icon
      width 17.5px
      height 15.5px
      margin-bottom 4px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m549eb962"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex549eb962%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex549eb962%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m549eb962"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index549eb962/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-calendar':getComponent(require("../../../components/calendar/index.mpx?isComponent&outputPath=components%2Findex2f88bd1e%2Findex")),'es-popup':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
